/* TODO: t() */
import React, { ComponentProps } from 'react';
import { View, StyleSheet } from 'react-native';

import Text from './Text';
import TextInput from './TextInput';
import { themeColors } from './Constants';

type Props = ComponentProps<typeof TextInput> & {
  maxLength: number;
  value: string;
  containerStyle?: StyleSet;
  style?: StyleSet;
};

function countNumberDigits(n: number) {
  return (Math.log(n) * Math.LOG10E + 1) | 0;
}

function TextInputCounter(props: Props) {
  let { maxLength, value, containerStyle, style, ...otherProps } = props;
  let maxLengthDigits = countNumberDigits(maxLength);
  let valueLength = String(value.length).padStart(maxLengthDigits, '0');

  return (
    <View style={[styles.container, containerStyle]}>
      <TextInput
        {...otherProps}
        style={[styles.input, style]}
        maxLength={maxLength}
        value={value}
      />
      <Text type="label" style={styles.countText}>
        {`${valueLength} / ${maxLength}`}
      </Text>
    </View>
  );
}

let styles = StyleSheet.create({
  container: {
    height: 34,
    borderWidth: 1,
    borderRadius: 3,
    flexDirection: 'row',
    borderColor: themeColors.borderGrey,
  },
  input: {
    height: 32,
    borderWidth: 0,
  },
  countText: {
    position: 'absolute',
    right: 12,
    fontWeight: '500',
    alignSelf: 'center',
    color: themeColors.darkGrey,
  },
});

export default TextInputCounter;
